<template>
    <div class="workPlan workSumary A4Container flexCloumnSingleCenter pageBreak_no">
        <div class="title flexCenter">实习管理工作总结</div>
        <div class="form" style="padding: 0!important;">
            <el-row class="el-row" style="line-height: 40px;border-bottom:1px solid #000;">
                <el-col :span="6" class="flexStart" style="border-right:1px solid #000;padding-left: 10px;">班级：{{
                    dataInfo.sxzj ? dataInfo.class_name : '' }}
                </el-col>
                <el-col :span="6" class="flexStart" style="border-right:1px solid #000;padding-left: 10px;">教师：{{
                    dataInfo.sxzj ? dataInfo.username : '' }}
                </el-col>
                <el-col :span="12" class="flexStart" style="padding-left: 10px;display: flex!important;">
                    <div>实习时间：</div>
                    <div class="flex_1 flexCenter">
                        {{ dataInfo.sxzj ? dataInfo.practice_start_date : '' }} 至
                        {{ dataInfo.sxzj ? dataInfo.practice_end_date : '' }}
                    </div>
                </el-col>
            </el-row>
            <!-- <div class="textIndent2" style="padding: 10px;line-height: unset;"
                v-html="dataInfo.sxzj ? dataInfo.sxzj.plan_desc : ''">
            </div> -->


            <div class="content"
                style="padding: 10px;line-height: unset;width:100%;height: 100%;overflow: hidden;box-sizing: border-box;position: relative;">
                <div id="divCntnrA_workSumary" style="width:100%;height: 100%;overflow: hidden;
      display: flex;flex-direction: column;justify-content: flex-start;align-items: anchor-center;">
                    <div id="resizeDivA_workSumary" class="scaleDiv_workSumary"
                        v-html="dataInfo.sxzj ? dataInfo.sxzj.plan_desc : ''"></div>
                </div>
            </div>



            <div class="posDate">{{ dataInfo.sxzj ? dataInfo.sxzj.create_date : '' }}</div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cover',
    props: {
        dataInfo: {
            type: Object,
            default: {}
        }
    },
    mounted() {
        let _this = this
        setTimeout(function () {
            _this.$nextTick(() => {
                console.log(36, _this.dataInfo)
                _this.resizeA().then(_ => {
                    _this.rescaleA()
                })
            })
        }, 500)
    },
    methods: {
        stripscript(s) {
            var pattern = new RegExp('\n')
            var rs = ''
            for (var i = 0; i < s.length; i++) {
                rs = rs + s.substr(i, 1).replace(pattern, '')
            }
            return rs
        },
        resizeA() {
            return new Promise((resolve, reject) => {
                let id1 = 'divCntnrA_workSumary'
                let id2 = 'resizeDivA_workSumary'

                let divHeight = document.getElementById(id1).offsetHeight
                let textHeight = document.getElementById(id2).offsetHeight
                // console.log('a', divHeight, textHeight)
                let i = 1
                while (textHeight > divHeight && i < 7) {
                    let pTag = document.getElementById(id2).querySelectorAll('p');
                    let olTag = document.getElementById(id2).querySelectorAll('ol');
                    let spanTag = document.getElementById(id2).querySelectorAll('span');
                    let pLen = pTag.length
                    let olLen = olTag.length
                    let spanLen = spanTag.length
                    // console.log(7575, pLen, olLen)
                    if (pTag) {
                        for (let tidx = 0; tidx < pLen; tidx++) {
                            pTag[tidx].style.margin = '0px';
                            pTag[tidx].style.fontSize = `${18 - i}px`;
                            // console.log("🌰", tidx);
                        }
                    }
                    if (olTag) {
                        for (let olidx = 0; olidx < olLen; olidx++) {
                            olTag[olidx].style.margin = '0px';
                            olTag[olidx].style.fontSize = `${18 - i}px`;
                            // console.log("🍑", olidx);
                        }
                    }
                    if (spanTag) {
                        for (let spanidx = 0; spanidx < spanLen; spanidx++) {
                            spanTag[spanidx].style.margin = '0px';
                            spanTag[spanidx].style.fontSize = `${18 - i}px`;
                            // console.log("🍑", spanidx);
                        }
                    }
                    document.getElementById(id2).style.fontSize = `${18 - i}px`
                    textHeight = document.getElementById(id2).offsetHeight
                    i++

                }
                resolve()
            })
        },
        rescaleA() {
            return new Promise((resolve, reject) => {
                let id1 = 'divCntnrA_workSumary'
                let id2 = 'resizeDivA_workSumary'

                let divHeight = document.getElementById(id1).offsetHeight
                let textHeight = document.getElementById(id2).offsetHeight
                // console.log('a', divHeight, textHeight)
                let i = 1

                while (textHeight > divHeight && i < 4) {
                    document.getElementsByClassName('scaleDiv')[0].style.transform = `scale(1, ${1 - i * 0.1})`
                    textHeight = document.getElementById(id2).offsetHeight * (1 - i * 0.1)
                    console.log(textHeight, divHeight, i, 1 - i * 0.1)
                    i++
                }
                resolve()
            })
        },
    }
}
</script>
<style lang="less" type="text/less">
.workSumary {
    p {
        margin: 0;
    }
}
</style>